import { useRef } from 'react'
import { formatNumber } from '@/utils/formatters'

export default ({
  value = '',
  placeholder = "",
  disabled = false,
  className = "",
  onChange,
  onFocus,
  onBlur
}) => {
  const ref = useRef(null)

  const formatValue = (value) => {
    if (!value) return ''
    return formatNumber(getRawValue(value))
  }

  const getRawValue = (value) => value.replace(/\s/g, '').replace(/,/g, '.')

  return <input
    className={className}
    ref={ref}
    placeholder={placeholder}
    value={value || ''}
    onFocus={ (e) => { 
      e.target.value = value ? value.toString().replace(/\s/g, '') : ''
      e.target.select()
      if(onFocus) onFocus(e)
    }}
    onBlur={ (e) => {
      const rawValue = getRawValue(e.target.value)
      const formattedValue = formatValue(rawValue)
      e.target.value = formattedValue
      if(onBlur) onBlur(e)
    }}
    onChange={ (e) => {
      const rawValue = e.target.value.replace(/\s/g, '').replace(/,/g, '.')
      onChange(rawValue)
    }}
    disabled={disabled}
  />
}